import { NgModule } from '@angular/core';
import {SharedModule} from "../../shared.module";
import { TabsPublicationobjectsComponent } from './tabs-publicationobjects/tabs-publicationobjects.component';
import {DynamicFormModule} from "../dynamic-form/dynamic-form.module";
import { TabsDynamicFormComponent } from './tabs-dynamic-form/tabs-dynamic-form.component';
import { TabsObjectArrayComponent } from './tabs-object-array/tabs-object-array.component';
import {DataTablesModule} from "angular-datatables";

@NgModule({
  imports: [
    SharedModule,
    DynamicFormModule,
	DataTablesModule,
  ],
  declarations: [
      TabsPublicationobjectsComponent,
      TabsDynamicFormComponent,
      TabsObjectArrayComponent
  ],
	exports: [
		TabsPublicationobjectsComponent,
		TabsDynamicFormComponent,
		TabsObjectArrayComponent
	]
})
export class TabsModule { }
